import React from "react";
import { FiSearch } from "react-icons/fi";

function cn(...parts: (string | undefined | false)[]): string {
  return parts.filter(Boolean).join(" ");
}

export interface SearchBarToHeaderProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "size" | "type"> {
  isToShowSearchBarMobile?: boolean;
  hasBorder?: boolean;
  submitLabel?: string;
  submitLoading?: boolean;
  onSearch?: () => void;
  formClassName?: string;
  hasError?: boolean;
  isToShowContentSelectedNumber?: number;
}

const SearchBarToHeader = React.forwardRef<
  HTMLInputElement,
  SearchBarToHeaderProps
>(
  (
    {
      isToShowSearchBarMobile = true,
      hasBorder: _hasBorder,
      submitLabel = "Buscar",
      submitLoading = false,
      onSearch,
      formClassName,
      hasError = false,
      isToShowContentSelectedNumber = 0,
      placeholder = "Pesquisar…",
      disabled,
      className,
      ...rest
    },
    ref
  ) => {
    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
      event.preventDefault();
      if (!disabled && !submitLoading) onSearch?.();
    };

    return (
      <form
        role="search"
        onSubmit={handleSubmit}
        className={cn(
          "relative flex w-full max-w-full min-w-0 flex-col items-stretch justify-center",
          "max-md:m-0",
          "md:ml-3",
          isToShowSearchBarMobile && "max-md:flex max-md:flex-col",
          "min-[400px]:max-md:flex min-[400px]:max-md:flex-col",
          formClassName,
          isToShowSearchBarMobile === false && "max-md:hidden"
        )}
      >
        <div
          className={cn(
            "box-border flex w-full min-w-0 max-w-md flex-row items-stretch overflow-hidden rounded-lg border border-solid transition-colors",
            "h-[35px]",
            hasError ? "border-[#FF3838]" : "border-[#B6B6B6]"
          )}
        >
          <div className="flex min-h-0 min-w-0 flex-1 items-center bg-white pl-2.5 pr-1.5">
            <FiSearch
              className="h-4 w-4 shrink-0 text-[#6B7280]"
              aria-hidden
            />
            <input
              ref={ref}
              type="search"
              disabled={disabled || submitLoading}
              placeholder={placeholder}
              autoComplete="off"
              className={cn(
                "ml-2 min-h-0 min-w-0 flex-1 border-0 bg-transparent text-xs leading-tight text-[#374151] outline-none",
                "placeholder:text-xs",
                hasError ? "placeholder:text-[#FF3838]" : "placeholder:text-[#9CA3AF]",
                className
              )}
              {...rest}
            />
            <button
              type="button"
              id="content-selected-button"
              className={cn(
                "ml-1 shrink-0 rounded border-0 bg-[#cce6ea] p-0 text-[11px] font-medium leading-none text-[#666666]",
                isToShowContentSelectedNumber >= 1
                  ? "flex h-[18px] w-[18px] items-center justify-center"
                  : "hidden"
              )}
            >
              {isToShowContentSelectedNumber}
            </button>
          </div>
          <button
            type="submit"
            disabled={disabled || submitLoading}
            className={cn(
              "flex shrink-0 cursor-pointer items-center justify-center self-stretch border-0 bg-[#6ea5ff] px-4 text-xs font-bold uppercase tracking-wide text-white",
              "disabled:cursor-not-allowed disabled:opacity-60"
            )}
          >
            {submitLoading ? "…" : submitLabel}
          </button>
        </div>
      </form>
    );
  }
);

SearchBarToHeader.displayName = "SearchBarToHeader";

export default SearchBarToHeader;
